import type { NavSectionProps } from "src/components/nav-section";

import { paths } from "src/routes/paths";

import { CONFIG } from "src/global-config";

import { Label } from "src/components/label";
import { SvgColor } from "src/components/svg-color";

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`${CONFIG.assetsDir}/assets/icons/navbar/${name}.svg`} />
);

const ICONS = {
  job: icon("ic-job"),
  blog: icon("ic-blog"),
  chat: icon("ic-chat"),
  mail: icon("ic-mail"),
  user: icon("ic-user"),
  file: icon("ic-file"),
  lock: icon("ic-lock"),
  tour: icon("ic-tour"),
  order: icon("ic-order"),
  label: icon("ic-label"),
  blank: icon("ic-blank"),
  kanban: icon("ic-kanban"),
  folder: icon("ic-folder"),
  course: icon("ic-course"),
  banking: icon("ic-banking"),
  booking: icon("ic-booking"),
  invoice: icon("ic-invoice"),
  product: icon("ic-product"),
  calendar: icon("ic-calendar"),
  disabled: icon("ic-disabled"),
  external: icon("ic-external"),
  menuItem: icon("ic-menu-item"),
  ecommerce: icon("ic-ecommerce"),
  analytics: icon("ic-analytics"),
  dashboard: icon("ic-dashboard"),
  parameter: icon("ic-parameter"),
  review: icon("ic-review"),
};

// ----------------------------------------------------------------------

export const navData: NavSectionProps["data"] = [
  /**
   * Overview
   */
  {
    subheader: "App",
    items: [
      { title: "Dashboard", path: paths.dashboard.root, icon: ICONS.dashboard },
      { title: "Users", path: paths.user, icon: ICONS.user },
      { title: "Categories", path: paths.category, icon: ICONS.ecommerce },
      { title: "Prayers", path: paths.prayer, icon: ICONS.blog },
      { title: "Tags", path: paths.tag, icon: ICONS.tour },
      // { title: "Reviews", path: paths.review, icon: ICONS.review },
    ],
  },
  /**
   * Management
   */
  {
    subheader: "Settings",
    items: [
      // {
      //   title: 'Group',
      //   path: paths.dashboard.group.root,
      //   icon: ICONS.user,
      //   children: [
      //     { title: 'Four', path: paths.dashboard.group.root },
      //     { title: 'Five', path: paths.dashboard.group.five },
      //     { title: 'Six', path: paths.dashboard.group.six },
      //   ],
      // },
      {
        title: "Change Password",
        path: paths.changePassword,
        icon: ICONS.lock,
      },
      { title: "Logout", path: "#", icon: ICONS.external },
    ],
  },
];
